import React, { useState, useEffect, useRef } from "react";
import { localAttributes } from "assets/constants";
import { KeyValuePair, objectTypeProps } from "types";
import "instantsearch.css/themes/satellite.css";
import styles from "./SearchOuterServices.module.scss";
import Text from "components/text/Text";
import { getAllClassNames, isDev, setParams } from "helpers";
import strings from "assets/strings";
import { visitHoursOptions } from "assets/constants";
import { ArrowLeft, ArrowUp } from "assets/icons";
import Button from "components/buttons/button/Button";
import Popup from "components/popup/Popup";
import { CustomLocalSearchInput } from "components/inputs/customLocalSearchInput/CustomLocalSearchInput";
import { CustomCheckboxesLocal } from "components/buttons/customCheckboxesLocal/CustomCheckboxesLocal";
import settings from "assets/mergeSettings";
import { AlertPopup } from "components/popup/alertPopup/AlertPopup";
import RadioButton from "components/radioButton/RadioButton";
import TextInput from "components/inputs/textInput/TextInput";
import { BubbleIcon } from "components/bubbleIcon/BubbleIcon";
//import { DropdownCheckboxes } from "components/dropdownCheckboxes/DropdownCheckboxes";
import SearchAdressMedicalCenters from "pages/MedicalCenters/SearchMedicalCenters/SearchAdressMedicalCenters";
import { SearchAdressMedicalCentersHandle } from "pages/MedicalCenters/SearchMedicalCenters/SearchAdressMedicalCenters";
import { Loader } from "components/Loader/Loader";
import { validateRecaptcha } from "../../../utils/recaptcha";

export function SearchOuterServices(props: objectTypeProps) {
  const { objectType } = props;
  const [expanded, setExpanded] = useState(false);
  const [city, setCity] = useState("");
  const [name, setName] = useState("");
  const [medicalServices, setMedicalServices] = useState<string>('');
  const [isMedicalServiceSelectedFromList, setIsMedicalServiceSelectedFromList] = useState(false);
  //const [medicalServiceForceReset, setMedicalServiceForceReset] = useState(false);
  const [workHours, setWorkHours] = useState<string[]>([])
  const [serviceCode, setServiceCode] = useState<string | number>('')
  const [selectedFieldOfService, setSelectedFieldOfService] = useState<string>(strings.searchOuterServices.fieldOfService)
  const [infoPopup, setInfoPopup] = useState('')
  const [switchSelected, setSwitchSelected] = useState(false)
  const divExpandRef = useRef<HTMLDivElement>(null);
  const submitButtonRef = useRef<HTMLButtonElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);

  const medicalServicesSearchRef = useRef<any>(null);
  const [selectedPlace, setSelectedPlace] = useState<{ city: string; lat: number | null; lng: number | null }>({
    city: "",
    lat: null,
    lng: null,
  });
  const [isValidAddress, setIsValidAddress] = useState(false);
  const [isAddressEnabled, setIsAddressEnabled] = useState(false);
  const citySearchRef = useRef<any>(null);
  const addressRef = useRef<SearchAdressMedicalCentersHandle>(null);
  const [loading, setLoading] = useState(false);



  const handleSelectedFieldOfService = (value: string) => {
    setSelectedFieldOfService(value)

    if (value === strings.searchOuterServices.serviceCode) {
      addressRef.current?.clear();
      setSelectedPlace({ city: "", lat: null, lng: null });
      setIsValidAddress(false);
      setIsAddressEnabled(false);
    }



    setMedicalServices('')
    setIsMedicalServiceSelectedFromList(false)
    setServiceCode('')
    //setMedicalServiceForceReset((prev) => !prev)
    medicalServicesSearchRef.current?.resetBubbles();

    if (value === strings.searchOuterServices.fieldOfService) setSwitchSelected(false)
    else setSwitchSelected(true)
  }

  useEffect(() => {
    if (divExpandRef.current && expanded) {
      const firstInput = divExpandRef.current.querySelector('input');
      if (firstInput) {
        firstInput.focus();
      }
    }
  }, [expanded]);

  useEffect(() => {
    if (isAddressEnabled) {
      setCity("");

      citySearchRef.current?.resetBubbles?.();
      citySearchRef.current?.reset?.();
      citySearchRef.current?.clear?.();
    }
  }, [isAddressEnabled]);


  const onSubmit = async (event: any) => {
    event.preventDefault();

    const isValid = await validateRecaptcha('search_outer_services');
    if (!isValid) {
      alert('אימות נכשל. נסה שוב.');
      return;
    }

    const hasValidAddress =
      selectedPlace.lat !== null &&
      selectedPlace.lng !== null &&
      isValidAddress;

    if (isAddressEnabled && !hasValidAddress) {
      handleToggleVisibility();
      setInfoPopup("יש לבחור כתובת מהרשימה");
      return;
    }


    if (objectType == 10 && selectedFieldOfService == strings.searchOuterServices.fieldOfService && !medicalServices) {
      handleToggleVisibility();
      setInfoPopup(strings.errorMessages.requiredFieldOfService);
      return;
    }

    if (objectType == 10 && selectedFieldOfService == strings.searchOuterServices.fieldOfService && medicalServices && !isMedicalServiceSelectedFromList) {
      handleToggleVisibility();
      setInfoPopup(strings.globalStrings.selectItemFromList);
      return;
    }

    if (objectType == 10 && selectedFieldOfService == strings.searchOuterServices.serviceCode && (!serviceCode || !serviceCode.toString().length)) {
      handleToggleVisibility();
      setInfoPopup(strings.errorMessages.requiredServiceCode);
      return;
    }

    if (objectType != 1 && objectType != 10 && !city && !name && !hasValidAddress) {
      handleToggleVisibility();
      return;
    }

    const formData: KeyValuePair[] = [];

    // const formData: KeyValuePair[] = [
    //   { key: `${[localAttributes.localOuterServiceName]}`, value: name },
    //   { key: `${[localAttributes.localMedicalServicesApiKey]}`, value: medicalServices },
    //   { key: `${[localAttributes.localCityCodeFieldName]}`, value: city },
    //   { key: `${[localAttributes.localWorkHoursFieldName]}`, value: workHours.join(',') },
    //   { key: `${[localAttributes.localServiceCodeFieldName]}`, value: String(serviceCode) },
    // ];

    if (name) {
      formData.push({ key: `${[localAttributes.localOuterServiceName]}`, value: name });
    }
    if (medicalServices) {
      formData.push({ key: `${[localAttributes.localMedicalServicesApiKey]}`, value: medicalServices });
    }
    if (city) {
      formData.push({ key: `${[localAttributes.localCityCodeFieldName]}`, value: city });
    }
    if (workHours.length > 0) {
      formData.push({ key: `${[localAttributes.localWorkHoursFieldName]}`, value: workHours.join(',') });
    }
    if (serviceCode && serviceCode.toString().length > 0) {
      formData.push({ key: `${[localAttributes.localServiceCodeFieldName]}`, value: String(serviceCode) });
    }

    if (selectedFieldOfService === strings.searchOuterServices.serviceCode) {
      setLoading(true);
    }

    if (hasValidAddress) {
      const loc = `${selectedPlace.lat},${selectedPlace.lng}`;
      formData.push(
        { key: "loc", value: loc },
        { key: "r", value: "20000" },
        { key: "geo", value: "1" }
      );

      window.location.href = `${settings.outerServiceSearchResults}?${setParams(formData)}`;
      return;
    }

    if (city && city.split(",").length === 1) {
      const cities = localStorage.getItem("cities");
      const citiesArr = cities ? JSON.parse(cities) : [];
      const cityObj = citiesArr.find((c: any) => c.cityCode === city);

      const locLat = cityObj?.latitude;
      const locLong = cityObj?.longitude;

      if (locLat !== null && locLat !== undefined && locLong !== null && locLong !== undefined) {
        formData.push(
          { key: `${[localAttributes.localLocFieldName]}`, value: `${locLat},${locLong}` },
          { key: `${[localAttributes.localRadiusFieldName]}`, value: "20000" }
        );
      }
    }

    if (selectedFieldOfService === strings.searchOuterServices.serviceCode) {
      setLoading(true);
    }

    window.location.href = `${settings.outerServiceSearchResults}?${setParams(formData)}`;
  };

  const handleToggleVisibility = () => {
    if (popupRef.current) {
      popupRef.current.classList.toggle('show');
    }
  };

  useEffect(() => {
    if (!isAddressEnabled) {
      setSelectedPlace({ city: "", lat: null, lng: null });
      setIsValidAddress(false);
    }
  }, [isAddressEnabled]);

  useEffect(() => {
    const resetSearchState = () => {
      setMedicalServices('');
      setIsMedicalServiceSelectedFromList(false);
      //setMedicalServiceForceReset((prev) => !prev);
      setWorkHours([]);
      setCity('');
      setName('');
      setServiceCode('');
      setSelectedFieldOfService(strings.searchOuterServices.fieldOfService);
      setLoading(false);

      citySearchRef.current?.resetBubbles?.();
      citySearchRef.current?.reset?.();
      citySearchRef.current?.clear?.();
      medicalServicesSearchRef.current?.resetBubbles?.();
    };

    window.addEventListener('popstate', resetSearchState);
    window.addEventListener('pageshow', resetSearchState);

    return () => {
      window.removeEventListener('popstate', resetSearchState);
      window.removeEventListener('pageshow', resetSearchState);
    };
  }, []);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      // if (submitButtonRef.current) {
      //   submitButtonRef.current.focus();
      // }
    }
  };

  // Rest of your component logic
  return (
    <div
      className={getAllClassNames([
        "ais-InstantSearch",
        isDev() && styles.devContainer,
      ])}
    >

      <div className={styles.container}>
        <div
          className={getAllClassNames([
            styles.searchDiv,
            expanded && styles.noBorderBottom,
          ])}
        >
          <div className={styles.searchDivWrapper}>
            <Text
              className={styles.serachTitle}
              text={strings.searchOuterServices.searchOuterServiceInstruction} />

            <div className={styles.searchFieldsWrapper}>
              {/* שם נותן השירות */}
              <div className={styles.divFlex}>
                <CustomLocalSearchInput
                  forceReset
                  isPopup
                  popupProps={{
                    title: strings.searchOuterServices.serviceProviderName,
                    subTitle: strings.searchOuterServices.canChooseFieldOfService,
                    placeholder: '',
                    keyToNormalize: 'name',
                    labelToNormalize: 'name',
                    //filterBy: 'medicalFieldName'
                    onSubmit: () => { },
                  }}
                  enableFreeText
                  enableNotAutoComplete
                  attribute={localAttributes.localDoctorNamesApiKey}
                  title={strings.searchOuterServices.serviceProviderName}
                  queryParams={[{ key: 'objectType', value: objectType }]}
                  onChange={(value: string) => setName(value)}
                  onReset={() => setName('')}
                />
              </div>

              {/* תחום שירות */}
              <div className={styles.divFlex}>
                <RadioButton
                  ariaLabel={strings.searchOuterServices.fieldOfService}
                  name="fieldOfService"
                  value={strings.searchOuterServices.fieldOfService}
                  isSelected={selectedFieldOfService === strings.searchOuterServices.fieldOfService}
                  onSelecteRadio={(value: string) => handleSelectedFieldOfService(value)}
                />

                <CustomLocalSearchInput
                  ref={medicalServicesSearchRef}
                  forceReset//={medicalServiceForceReset}
                  isPopup
                  popupProps={{
                    title: strings.searchOuterServices.fieldOfService,
                    subTitle: strings.searchOuterServices.canChooseFieldOfService,
                    placeholder: '',
                    keyToNormalize: localAttributes.localMedicalFieldName,
                    labelToNormalize: localAttributes.localMedicalFieldName,
                    //filterBy: 'medicalFieldName',
                    onSubmit: () => { },
                  }}
                  enableFreeText={!switchSelected}
                  enableNotAutoComplete
                  attribute={localAttributes.localMedicalApiKey}
                  title={strings.searchOuterServices.fieldOfService}
                  queryParams={[{ key: 'objectType', value: objectType }]}
                  onChange={(value: string, hasSubField?: boolean) => {
                    setMedicalServices(value);
                    if (!value) {
                      setIsMedicalServiceSelectedFromList(false);
                      return;
                    }

                    setIsMedicalServiceSelectedFromList(typeof hasSubField !== 'undefined');
                  }}
                  onContinue={(value: string) => {
                    setMedicalServices(value);
                    setIsMedicalServiceSelectedFromList(true);
                  }}
                  onReset={() => {
                    setMedicalServices('');
                    setIsMedicalServiceSelectedFromList(false);
                  }}
                />

                {/* <DropdownCheckboxes
                  isSwitchSelected={switchSelected}
                  title={strings.searchOuterServices.fieldOfService}
                  objectType='10'
                  disabled={selectedFieldOfService === strings.searchOuterServices.serviceCode}
                  className={styles.dropdownCheckboxes}
                  attribute={localAttributes.localMedicalApiKey}
                  keyToNormalize={localAttributes.localMedicalFieldName}
                  labelToNormalize={localAttributes.localMedicalFieldName}
                  dropDownClass={styles.dropDownClass}
                  setQueryParams={(values: string[]) => setMedicalServices(values)}
                /> */}
              </div>

              {/* קוד שירות */}
              <div className={getAllClassNames([styles.divFlex, styles.serviceCodeRow])}>
                <div className={getAllClassNames([styles.labelWrapper])}>
                  <RadioButton
                    ariaLabel={strings.searchOuterServices.serviceCode}
                    name="fieldOfService"
                    label={strings.searchOuterServices.serviceCode}
                    value={strings.searchOuterServices.serviceCode}
                    className={styles.label}
                    isSelected={selectedFieldOfService === strings.searchOuterServices.serviceCode}
                    onSelecteRadio={(value: string) => handleSelectedFieldOfService(value)}
                  />
                  {(strings.searchOuterServices.tooltipTitle || strings.searchOuterServices.tooltipContent) && ( 
                  <BubbleIcon
                      isPopup
                      popupTitle={strings.searchOuterServices.tooltipTitle}
                      popupContent={strings.searchOuterServices.tooltipContent}
                      text={strings.globalStrings.whatIsThis}
                      info={strings.searchOuterServices.serviceCodeInfo}
                      className={styles.bubbleIcon}
                    />
                  )}
                </div>

                {selectedFieldOfService === strings.searchOuterServices.serviceCode ? (
                  <CustomLocalSearchInput
                    forceReset
                    popupProps={{
                      title: strings.searchOuterServices.serviceCode,
                      subTitle: strings.searchOuterServices.serviceCodeInfo,
                      placeholder: strings.searchOuterServices.serviceCode,
                      keyToNormalize: "code",
                      labelToNormalize: "name", 
                      onSubmit: () => { },
                    }}
                    placeholder={strings.searchOuterServices.serviceCode}
                    enableFreeText
                    enableNotAutoComplete
                    attribute={localAttributes.localServiceCodesApiKey}
                    queryParams={[{ key: "objectType", value: objectType }]}
                    onChange={(value: string) => setServiceCode(value)}
                    onContinue={(value: string) => setServiceCode(value)}
                    onReset={() => setServiceCode("")}
                  />
                ) : (
                  <TextInput
                    ariaLabel={strings.searchOuterServices.serviceCode}
                    typedValue={serviceCode.toString()}
                    onChange={(value) => setServiceCode(value)}
                    onKeyDown={handleKeyDown}
                    isDisabled
                  />
                )}
              </div>

              {/* ישוב */}
              <CustomLocalSearchInput
                ref={citySearchRef}
                forceReset
                multiSelect
                isPopup
                popupProps={{
                  title: strings.globalStrings.chooseCity,
                  subTitle: strings.globalStrings.canChooseCity,
                  placeholder: strings.globalStrings.searchCity,
                  keyToNormalize: 'cityCode',
                  labelToNormalize: 'city',
                  //filterBy: 'city',
                  onSubmit: () => { },
                }}
                placeholder={strings.globalStrings.cityPlaceholder}
                enableFreeText={!isAddressEnabled}
                showRadioButtonCheckBox={true}
                isEnabledRadioButton={!isAddressEnabled}
                setIsEnabledRadioButton={setIsAddressEnabled}
                attribute={localAttributes.localCitiesApiKey}
                queryParams={[{ key: 'objectType', value: objectType }]}
                title={strings.globalStrings.city}
                onChange={(value: string) => { setCity(value) }}
                onContinue={(value: string) => setCity(value)}
                onReset={() => setCity('')}
              />
              <div className={styles.divFlex}>
                {/* בכתובת או בקרבתה */}
                <SearchAdressMedicalCenters
                  ref={addressRef}
                  onPlaceSelected={(details) =>{
                    setSelectedPlace({
                      city: details.city,
                      lat: details.lat,
                      lng: details.lng,
                    });
                    //setCity("");
                  }}
                  isEnabled={isAddressEnabled}
                  setIsEnabled={setIsAddressEnabled}
                  setIsValidAddress={setIsValidAddress}
                  disabled={
                    //selectedFieldOfService === strings.searchOuterServices.serviceCode||
                    name.trim().length > 0
                  }
                />
              </div>
            </div>

          </div>

        </div>


        {expanded && (
          <div className={styles.divExpand} ref={divExpandRef}>
            <CustomCheckboxesLocal
              onSetSelected={(selectedData: string[]) => setWorkHours(selectedData)}
              title={strings.globalStrings.visitHours}
              options={visitHoursOptions}
              selectedCheckboxes={workHours}
            />
          </div>
        )}
        {settings.showAdvanceSearch ?
          <div className={styles.divBottom}>
            <div>
              <Text
                onClick={() => setExpanded(!expanded)}
                className={styles.textAdvance}
                text={expanded ? strings.globalStrings.closeAdvancedSearch : strings.globalStrings.advanceSearch}
              />
              {expanded ? (
                <ArrowUp className={styles.icon} />
              ) : (
                <ArrowLeft className={styles.icon} />
              )}

            </div>
            <Button
              onClick={onSubmit}
              text={strings.globalStrings.search}
              replaceClassName={styles.button}
            />
          </div> :
          <div className={styles.divBottomNoAavanced}>
            <Button
              ref={submitButtonRef}
              onClick={onSubmit}
              text={strings.globalStrings.search}
              replaceClassName={styles.button}
            />
          </div>
        }
      </div>
      {
        <Popup
          ref={popupRef}
          onClose={() => handleToggleVisibility()}
          height={284}
          width={550}
          style={{ paddingBottom: '0px' }}
        >
          <AlertPopup
            title={strings.errorMessages.notice}
            subTitle={objectType == 10 ? infoPopup : strings.errorMessages.requiredProperties}
            showButton
            buttonText={strings.globalStrings.close}
            onClose={() => handleToggleVisibility()}
          ></AlertPopup>
        </Popup>
      }
      <Loader visible={loading} />
    </div>
  );
}

export default SearchOuterServices;
